<template>
  <div>
    <button
      v-on="listeners"
      v-bind="attrs"
      type="button"
      :class="[setTheme, isLoading, {'cursor-not-allowed': disabled}]"
      class="group flex rounded-md items-center w-full px-2 py-2 text-sm"
      :aria-label="ariaLabel"
      :disabled="disabled"
    >
      <slot/>
    </button>
  </div>
</template>
<script>
export default {
  name: 'item-nav',
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'light'
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    setTheme: function () {
      return {
        'bg-white hover:bg-primary-50 hover:text-primary active:bg-primary-100': this.theme === 'light',
        'bg-secondary-800 dark:bg-darkblue-900 text-white hover:bg-secondary-900 dark:hover:bg-darkblue active:bg-secondary dark:active:bg-darkblue-600 dark:active:text-primary focus:bg-secondary-900 dark:focus:bg-darkblue': this.theme === 'dark',
        'bg-primary-800 hover:bg-primary-900 active:bg-primary-900 text-white dark:bg-primary-800 dark:active:bg-primary-800 dark:hover:bg-primary-600': this.theme === 'primary',
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
  }
}
</script>
